<div class="alert-window">
  <h3 *ngIf="this.code !== undefined">Code: {{ this.code }}</h3>
  <p [class.full-text]="!isCollapsed" [class.preview-text]="isCollapsed" class="mg-b-s">
    {{ isCollapsed ? (this.message.length > 100 ? (this.message | slice:0:100) + '...' : this.message) : this.message }}
  </p>
  <span (click)="toggleText()" *ngIf="isCollapsed && this.message.length > 100" class="expand-text" role="button" tabindex="0">view all text</span>
  <button (click)="onCloseClick()" class="mat-mdc-snack-bar-action mdc-snackbar__action mdc-button mat-mdc-button mat-mdc-button-base">close</button>
</div>
